goog.provide("shadow.js.shim.module$src$svg$wpp$content$calendar_svg$default");
shadow.js.shim.module$src$svg$wpp$content$calendar_svg$default = shadow.js.shim.module$src$svg$wpp$content$calendar_svg.default;
